module.exports = __webpack_public_path__ + "img/arrow-point-to-right.a1d7c1fe.svg";